getStorageArgs